import React from "react";

/**
 * Chat icon button with an optional unread-count badge.
 * Props: onClick, count (number), title
 */
const ChatIconWithBadge = ({
  onClick,
  count = 0,
  title = "Chat",
  className,
}) => {
  return (
    <button
      type="button"
      className={className}
      title={title}
      onClick={onClick}
      style={{
        position: "relative",
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: 4,
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.75C9.54676 2.75 7.19398 3.72455 5.45927 5.45926C3.72456 7.19397 2.75001 9.54675 2.75001 12C2.75001 13.481 3.09801 14.879 3.71501 16.118C3.96301 16.616 4.05801 17.21 3.90201 17.795L3.30601 20.02C3.28099 20.1132 3.28093 20.2114 3.30586 20.3046C3.33078 20.3979 3.37981 20.4829 3.44801 20.5512C3.51621 20.6195 3.60118 20.6687 3.69438 20.6937C3.78759 20.7188 3.88576 20.7189 3.97901 20.694L6.20601 20.098C6.76878 19.9537 7.36489 20.0202 7.88201 20.285C9.16111 20.9221 10.571 21.2525 12 21.25C14.4533 21.25 16.806 20.2754 18.5407 18.5407C20.2755 16.806 21.25 14.4533 21.25 12C21.25 9.54675 20.2755 7.19397 18.5407 5.45926C16.806 3.72455 14.4533 2.75 12 2.75ZM1.25001 12C1.25001 6.063 6.06301 1.25 12 1.25C17.937 1.25 22.75 6.063 22.75 12C22.75 17.937 17.937 22.75 12 22.75C10.282 22.75 8.65601 22.346 7.21301 21.628C7.02254 21.5281 6.8026 21.4997 6.59301 21.548L4.36701 22.143C2.84301 22.551 1.44901 21.157 1.85701 19.633L2.45301 17.407C2.50128 17.1974 2.4729 16.9775 2.37301 16.787C1.63215 15.3001 1.24767 13.6612 1.25001 12ZM7.25001 10.5C7.25001 10.3011 7.32903 10.1103 7.46968 9.96967C7.61033 9.82902 7.8011 9.75 8.00001 9.75H16C16.1989 9.75 16.3897 9.82902 16.5303 9.96967C16.671 10.1103 16.75 10.3011 16.75 10.5C16.75 10.6989 16.671 10.8897 16.5303 11.0303C16.3897 11.171 16.1989 11.25 16 11.25H8.00001C7.8011 11.25 7.61033 11.171 7.46968 11.0303C7.32903 10.8897 7.25001 10.6989 7.25001 10.5ZM7.25001 14C7.25001 13.8011 7.32903 13.6103 7.46968 13.4697C7.61033 13.329 7.8011 13.25 8.00001 13.25H13.5C13.6989 13.25 13.8897 13.329 14.0303 13.4697C14.171 13.6103 14.25 13.8011 14.25 14C14.25 14.1989 14.171 14.3897 14.0303 14.5303C13.8897 14.671 13.6989 14.75 13.5 14.75H8.00001C7.8011 14.75 7.61033 14.671 7.46968 14.5303C7.32903 14.3897 7.25001 14.1989 7.25001 14Z"
          fill="#626276"
        />
      </svg>
      {count > 0 && (
        <span
          style={{
            position: "absolute",
            top: -2,
            right: -2,
            minWidth: 16,
            height: 16,
            padding: "0 4px",
            borderRadius: 8,
            background: "#e53935",
            color: "#fff",
            fontSize: 10,
            fontWeight: 700,
            lineHeight: "16px",
            textAlign: "center",
            boxShadow: "0 0 0 2px #fff",
          }}
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
};

export default ChatIconWithBadge;
